import { useTranslation } from 'react-i18next'

import { formatMoney } from 'common'

import { AllowanceFrequencyType, getBenefitDetails, getBenefitUsageDetails } from 'core'

import { Card, Col, Row, Skeleton, charts } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

//
import CategoryInformation from '../categoryInformation'

//
import './styles.less'

type AvailableAllowanceCardProps = {
  planPeriodId: string
  startDate: Date
  endDate: Date
  monthlyAllowance: number
  offerSameAllowance: boolean
  isPerkContinuous: boolean
  runOutDays: number
  daysToRunOut: number
  allowanceFrequencies: AllowanceFrequencyType[]
}

const AvailableAllowanceCard = ({
  planPeriodId,
  startDate,
  endDate,
  monthlyAllowance,
  allowanceFrequencies,
  offerSameAllowance,
  isPerkContinuous,
  runOutDays,
  daysToRunOut,
}: AvailableAllowanceCardProps) => {
  const { data: stats, isLoading: areStatsLoading } = useQueryRequestV2({
    queryFn: () => getBenefitUsageDetails(planPeriodId),
    initialState: {
      totalUsage: {
        id: 0,
        categoryName: '',
        totalAllowance: 0,
        allowanceUsed: 0,
        availableAllowance: 0,
        percentageIncrease: 0,
        percentageUsed: 0,
        color: '',
      },
      categoryUsages: [],
      offerSameAllowance: false,
    },
  })
  const { t } = useTranslation()

  const { data: planPeriodDetails } = useQueryRequestV2({
    queryFn: () => getBenefitDetails(planPeriodId),
  })

  // @ts-ignore
  return (
    <Skeleton loading={areStatsLoading}>
      <div className="pb-16">
        <Card>
          <Row justify="space-between">
            <Col span={14}>
              <div className="statistic-card__content-wrap text-left">
                <span className="color-gray-7 font-14 mb-16">
                  {t('ee-dashboard.home.statistics.available-allowance-card')}
                </span>
                <p className="statistic-card__title">{formatMoney(stats.totalUsage.availableAllowance, true)}</p>

                <div>
                  <CategoryInformation
                    isContinuous={isPerkContinuous}
                    runOutDays={runOutDays}
                    daysToRunOut={daysToRunOut}
                    startDate={startDate}
                    endDate={endDate}
                    monthlyAllowanceValue={offerSameAllowance ? monthlyAllowance : stats.totalUsage.totalAllowance}
                    type={allowanceFrequencies.find((x) => x.id == stats.categoryUsages[0]?.allowanceFrequency)?.name}
                    benefitEndDate={planPeriodDetails?.endDate}
                  />
                </div>
              </div>
            </Col>
            <Col span={10} className="flex flex__center">
              <charts.Pie
                data={[
                  {
                    type: 'Data',
                    value: (stats.totalUsage.allowanceUsed / stats.totalUsage.totalAllowance) * 100,
                    color: stats.totalUsage.color,
                  },
                ]}
                statistics={{
                  title: 'Monthly usage',
                  content: `${stats.totalUsage.percentageUsed}%`,
                }}
                width={250}
                height={250}
              />
            </Col>
          </Row>
        </Card>
      </div>
    </Skeleton>
  )
}

export default AvailableAllowanceCard
